import { REPRINT_ID_ANCHOR } from '../utils';
import { getConfiguration } from "./configuration";

export function getBarcodeIdTicket(id, reprint) {
	const conf = getConfiguration();
	if(reprint && conf.rs.pprp) {
		//id = REPRINT_ID_ANCHOR + id;
		id = id + REPRINT_ID_ANCHOR;

	}
	return id;
}
